import { useInfiniteQuery } from '@tanstack/react-query';
import { apiGet, type ApiError } from '../lib/api';

export const AUDIT_ACTIONS = [
  'list_users',
  'view_user_overview',
  'view_timeline',
  'view_transcript',
  'view_reflections',
  'view_check_ins',
  'view_audit',
  'view_access_failures',
  'reset_test_account',
  'view_feedback',
] as const;

export interface AuditRow {
  id: string;
  actor_user_id: string;
  actor_email: string;
  action: string;
  subject_user_id: string | null;
  subject_email: string | null;
  resource: string | null;
  reason: string | null;
  request_id: string | null;
  ip: string | null;
  created_at: string;
}

export interface AuditPage {
  rows: AuditRow[];
  next_cursor: string | null;
}

export interface AuditFilters {
  actor: string;
  subject: string;
  action: string | null;
}

export function useAudit(filters: AuditFilters) {
  return useInfiniteQuery<AuditPage, ApiError>({
    queryKey: ['admin', 'audit', filters],
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.next_cursor,
    queryFn: ({ pageParam }) =>
      apiGet('/admin/audit', {
        actor: filters.actor || undefined,
        // Only sent when it looks like a uuid — the API rejects anything else with
        // a 400, and a half-typed id in the box should not blank the table.
        subject: /^[0-9a-f-]{36}$/i.test(filters.subject) ? filters.subject : undefined,
        action: filters.action ?? undefined,
        cursor: (pageParam as string | null) ?? undefined,
        limit: 50,
      }) as Promise<AuditPage>,
  });
}
